import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

function Svg(props: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}
    />
  );
}

/** A film clapperboard: the cinema. */
export function ClapperIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="3" y="9" width="18" height="12" rx="2" />
      <path d="M3 9l2-5 4 1-2 4M9 5l4 1-2 4M13 6l4 1-2 4M17 7l3 1-1 3" />
    </Svg>
  );
}

/** A sticker with a curled corner: the sticker book. */
export function StickerBookIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M5 4h10l4 4v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
      <path d="M15 4v4h4" />
      <path d="M9 14l2 2 4-5" />
    </Svg>
  );
}

/** The island chest, drawn in the path's 0-centred SVG space (a stop disc is 26 in radius). */
export function ChestGlyph({ fg }: { fg: string }) {
  return (
    <>
      <path d="M-13 -2 v-5 a13 8 0 0 1 26 0 v5 z" fill={fg} />
      <rect x={-13} y={-2} width={26} height={14} rx={2} fill={fg} />
      <rect x={-3} y={-3} width={6} height={8} rx={1.5} fill="rgba(30,36,51,0.35)" />
    </>
  );
}

/** A big chest for the opening overlay; the lid lifts when `open`. */
export function Chest({
  state,
  className = '',
}: {
  state: 'closed' | 'opening' | 'open';
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 200 160"
      className={`chest ${className}`}
      data-state={state}
      aria-hidden
      data-testid="chest"
    >
      {/* the glow that spills out when it opens */}
      {state === 'open' && (
        <ellipse className="chest-glow" cx={100} cy={70} rx={70} ry={34} fill="#FFE9A8" />
      )}
      <rect x={24} y={70} width={152} height={72} rx={8} fill="#B97A3E" />
      <rect x={24} y={92} width={152} height={10} fill="#8B5A2B" opacity={0.55} />
      <rect x={60} y={70} width={12} height={72} fill="#E9B030" />
      <rect x={128} y={70} width={12} height={72} fill="#E9B030" />
      <g className="chest-lid">
        <path d="M24 70 v-18 a76 40 0 0 1 152 0 v18 z" fill="#CF8F4C" />
        <rect x={60} y={44} width={12} height={26} fill="#E9B030" />
        <rect x={128} y={44} width={12} height={26} fill="#E9B030" />
      </g>
      <rect
        x={88}
        y={78}
        width={24}
        height={26}
        rx={5}
        fill="#F2C94C"
        stroke="#B88414"
        strokeWidth={3}
      />
      <circle cx={100} cy={91} r={4} fill="#8B5A2B" />
    </svg>
  );
}
